import { render, staticRenderFns } from "./NewAlertContext.vue?vue&type=template&id=963501c6&scoped=true"
import script from "./NewAlertContext.vue?vue&type=script&lang=js"
export * from "./NewAlertContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963501c6",
  null
  
)

export default component.exports